export default __webpack_public_path__ + "static/media/in.c65ced94.webp";